import { appPageTransition } from "../common";

(() => {
  if ("undefined" === typeof CURRENT_APP || CURRENT_APP !== "cocktail") {
    return;
  }

  const CHOICES = {};
  const set = (key, value) => (CHOICES[key] = value);
  const push = (key, value) => CHOICES[key].push(value);

  const numSpirits = $(".cocktail-spirit").length;

  const setAll = (key) => {
    set(key, []);

    $(`.cocktail-${key}:checked`).each(function () {
      let value = $(this).attr("id").split("-").pop();

      if (value !== "any") {
        push(key, value);
      }
    });
  };

  // alcool
  $("#cocktail-alcool-yes").on("click", () => {
    set("alcool", true);
    appPageTransition("cocktail-alcool", "cocktail-strong");
  });

  $("#cocktail-alcool-no").on("click", () => {
    set("alcool", false);
    appPageTransition("cocktail-alcool", "cocktail-milk");
  });

  // strong
  $("#cocktail-strong-yes").on("click", () => {
    set("strong", true);
    appPageTransition("cocktail-strong", "cocktail-spirit");
  });

  $("#cocktail-strong-no").on("click", () => {
    set("strong", false);
    appPageTransition("cocktail-strong", "cocktail-spirit");
  });

  $("#cocktail-strong-any").on("click", () =>
    appPageTransition("cocktail-strong", "cocktail-spirit")
  );

  // spirit
  $(".cocktail-spirit").on("change", function () {
    if (
      $(this).attr("id") === "cocktail-spirit-any" &&
      $(this).prop("checked")
    ) {
      $(".cocktail-spirit").prop("checked", true);
    } else if ($(".cocktail-spirit:checked").length < numSpirits) {
      $("#cocktail-spirit-any").prop("checked", false);
    }

    if ($(".cocktail-spirit:checked").length === 0) {
      $("#cocktail-spirit-continue").addClass("d-none");
    } else {
      $("#cocktail-spirit-continue").removeClass("d-none");
    }
  });

  $("#cocktail-spirit-continue").on("click", () => {
    setAll("spirit");
    CHOICES["strong"]
      ? setSuggestion("cocktail-spirit")
      : appPageTransition("cocktail-spirit", "cocktail-fruit");
  });

  // fruit
  $("#cocktail-fruit-citric").on("click", () => {
    set("fruit", "citric");
    setSuggestion("cocktail-fruit");
  });

  $("#cocktail-fruit-yes").on("click", () => {
    set("fruit", true);
    setSuggestion("cocktail-fruit");
  });

  $("#cocktail-fruit-no").on("click", () => {
    set("fruit", false);
    setSuggestion("cocktail-fruit");
  });

  // milk
  $("#cocktail-milk-yes").on("click", () => {
    set("milk", true);
    setSuggestion("cocktail-milk");
  });

  $("#cocktail-milk-no").on("click", () => {
    set("milk", false);
    setSuggestion("cocktail-milk");
  });

  // suggestion
  const setSuggestion = (current) => {
    appPageTransition(current, "cocktail-loading");

    setTimeout(() => {
      fetch(
        `/mvc/products/actions/search${EXT}?term=cocktail&alcool=${CHOICES["alcool"]}`
      )
        .then((response) => response.json())
        .then((cocktails) => {
          console.log(cocktails);
          let possibleCocktails = cocktails.filter(canBeSuggestion);
          let featuredCocktails = possibleCocktails.filter(
            (cocktail) => cocktail.featured === "1"
          );

          let cocktail = null;

          if (featuredCocktails.length > 0) {
            cocktail = featuredCocktails.splice(
              Math.floor(Math.random() * featuredCocktails.length),
              1
            )[0];
          } else if (possibleCocktails.length > 0) {
            cocktail = possibleCocktails.splice(
              Math.floor(Math.random() * possibleCocktails.length),
              1
            )[0];
          } else {
            // no cocktail found
            $("#cocktail-ns-msg").html(noSuggestionMessage());
            appPageTransition("cocktail-loading", "cocktail-no-suggestion");
            return;
          }

          $("#cocktail-img").attr("src", `/img/menu/${cocktail.image}.png`);
          $("#cocktail-title").text(cocktail.title);
          $("#cocktail-description").text(cocktail.description);
          $("#cocktail-price").text(`${cocktail.price}€`);

          if (featuredCocktails.length > 0 || possibleCocktails.length > 0) {
            if (featuredCocktails.length > 0) {
              cocktail = featuredCocktails.splice(
                Math.floor(Math.random() * featuredCocktails.length),
                1
              )[0];
            } else {
              cocktail = possibleCocktails.splice(
                Math.floor(Math.random() * possibleCocktails.length),
                1
              )[0];
            }

            $("#cocktail-other-img").attr(
              "src",
              `/img/menu/${cocktail.image}.png`
            );
            $("#cocktail-other-title").text(cocktail.title);
            $("#cocktail-other-description").text(cocktail.description);
            $("#cocktail-other-price").text(`${cocktail.price}€`);

            $("#cocktail-suggestion-next").removeClass("d-none");
          }

          $("#cocktail-again").removeClass("d-none");

          appPageTransition("cocktail-loading", "cocktail-suggestion");
        });
    }, 500);
  };

  $("#cocktail-suggestion-next").on("click", () =>
    appPageTransition("cocktail-suggestion", "cocktail-suggestion-other")
  );

  $("#cocktail-suggestion-prev").on("click", () =>
    appPageTransition("cocktail-suggestion-other", "cocktail-suggestion", {
      out: "right",
      in: "left",
    })
  );

  const noSuggestionMessage = () => {
    let msg = `<strong>Álcool:</strong>&nbsp;${
      CHOICES["alcool"] ? "sim" : "não"
    }`;

    checkChoice(
      "strong",
      (strong) =>
        (msg += `<br><strong>Forte:</strong>&nbsp;${strong ? "sim" : "não"}`)
    );
    checkChoice(
      "spirit",
      (spirit) =>
        (msg += `<br><strong>Gostos:</strong>&nbsp;${spirit.join(", ")}`)
    );
    checkChoice(
      "fruit",
      (fruit) =>
        (msg += `<br><strong>Fruta:</strong>&nbsp;${
          fruit ? `${fruit === true ? "sim" : "citrinos"}` : "não"
        }`)
    );
    checkChoice(
      "milk",
      (mlik) =>
        (msg += `<br><strong>Leite:</strong>&nbsp;${mlik ? "sim" : "não"}`)
    );

    return msg;
  };

  const SPIRITS = [
    "absinto",
    "cachaca",
    "gin",
    "rum",
    "tequila",
    "vodka",
    "whisky",
  ];

  const FRUIT_CITRIC = ["lima", "laranja natural"];
  const FRUIT_OTHER = ["morango", "kiwi", "macã", "ananás"];

  const MILKS = ["milk", "leite", "natas", "cream", "chantili", "chantilly"];

  const getSpirits = (cocktail) => {
    let desc = cocktail.description.toLowerCase().replaceAll("ç", "c");
    return SPIRITS.filter((s) => desc.includes(s));
  };

  const countSpirits = (cocktail) => {
    let ingredients = cocktail.description.toLowerCase().split("+");
    return ingredients
      .map((i) => (SPIRITS.filter((s) => i.includes(s)).length > 0 ? 1 : 0))
      .reduce((acc, count) => acc + count);
  };

  const hasMilk = (cocktail) => {
    let desc =
      cocktail.title.toLowerCase().replaceAll("ç", "c") +
      cocktail.description.toLowerCase().replaceAll("ç", "c");

    return MILKS.filter((m) => desc.includes(m)).length > 0;
  };

  const hasCitricFruit = (cocktail) => {
    let desc = cocktail.description.toLowerCase().replaceAll("ç", "c");
    return FRUIT_CITRIC.filter((m) => desc.includes(m)).length > 0;
  };

  const hasOtherFruit = (cocktail) => {
    let desc = cocktail.description.toLowerCase().replaceAll("ç", "c");
    return FRUIT_OTHER.filter((m) => desc.includes(m)).length > 0;
  };

  const checkFruit = (cocktail, fruit) => {
    return (
      (fruit === "citric" &&
        (!hasCitricFruit(cocktail) || hasOtherFruit(cocktail))) ||
      (fruit && !hasCitricFruit(cocktail) && !hasOtherFruit(cocktail)) ||
      (!fruit && (hasCitricFruit(cocktail) || hasOtherFruit(cocktail)))
    );
  };

  const checkChoice = (choice, callback) => {
    if ("undefined" !== typeof CHOICES[choice]) {
      return callback(CHOICES[choice]);
    }

    return false;
  };

  const canBeSuggestion = (cocktail) => {
    if (
      checkChoice(
        "strong",
        (strong) =>
          (strong && countSpirits(cocktail) < 2) ||
          (!strong && countSpirits(cocktail) > 1)
      )
    ) {
      return false;
    }

    if (
      checkChoice(
        "spirit",
        (spirit) =>
          !getSpirits(cocktail)
            .map((s) => spirit.includes(s))
            .includes(true)
      )
    ) {
      return false;
    }

    if (checkChoice("fruit", (fruit) => checkFruit(cocktail, fruit))) {
      return false;
    }

    if (checkChoice("milk", (milk) => !milk && hasMilk(cocktail))) {
      return false;
    }

    return true;
  };
})();
